import {gql} from "@irati/utils/gql"

import graph from "@irati/utils/services/graph"
import {StatementItemContentFragment} from "./fragments/statementItemContent"

const service = {
  list: (
    walletOwnerId: string,
    walletId: string,
    cursor: string | null = null,
    limit = 15,
    knownTypes: string[] = [],
    options: any = {}
  ) => {
    const query = gql`
      query StatementItems($walletOwnerId: String!, $walletId: String!, $cursor: String, $limit: Int, $knownTypes: [String!]) {
        statementItems(walletOwnerId: $walletOwnerId, walletId: $walletId, cursor: $cursor, limit: $limit, knownTypes: $knownTypes) {
          cursor
          results {
            uuid
            availableBalance
            content {
              ...StatementItemContentFragment
            }
            transfer {
              uuid
              amount
              currency
              createdAt
              type
              message
              sourceUser {
                firstName
                lastName
                email
              }
              perksGOCashback {
                image
                title
                location
                transactionAmount
                lastFour
                dealHeader
                dealUrlSlug
                dealUuid
                transactionDate
                isPerksGoRetailDeal
                savingPercent
              }
              spend {
                dealHeader
                dealThumbnailImage
                redemptionUuid
                orderTotal {
                  value
                  currency
                }
              }
              manualCredit {
                currency
                transactionAmount
              }
              sendCreditAsReward {
                service
                recipient_user_id
                rewards_wallet_id
                order_id
                rewardOrder {
                  createdBy {
                    firstname
                    lastname
                  }
                  reward {
                    thumbnailImage
                  }
                }
              }
              sendCredit {
                sender {
                  uuid
                  firstname
                  lastname
                  profile_img
                }
                recipient {
                  uuid
                  firstname
                  lastname
                  profile_img
                }
              }
            }
          }
        }
      }

      ${StatementItemContentFragment}
    `
    const toString = query.loc.source.body
    const variables = {
      walletOwnerId,
      walletId,
      cursor,
      limit,
      knownTypes
    }
    return graph({query: toString, variables}, options).then((response) => response.statementItems)
  }
}

export const getStatementItems = service.list

export default service
